/**
 * RingoSelect
 * @type {NodeListOf<HTMLElementTagNameMap[string]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[string]>}
 */

let RSelect = document.querySelectorAll('.Ringo-Select')
if (typeof RSelect != 'undefined') {
  RSelect.forEach(function (elem) {
    let ul = document.createElement('ul')
    ul.classList.add('Ringo-Select__generated')
    const longueur = elem.getElementsByTagName('option').length
    let divSelect = document.createElement('div')
    divSelect.classList.add('Ringo-Select__divSelect')

    for (let i = 0; i < longueur; i++) {
      let opt = document.createElement('li')
      opt.innerHTML = elem.getElementsByTagName('option')[i].innerHTML
      opt.setAttribute(
        'data-value',
        elem.getElementsByTagName('option')[i].value
      )
      opt.setAttribute(
        'data-index',
        elem.getElementsByTagName('option')[i].index
      )
      opt.value = elem.getElementsByTagName('option')[i].value
      if (elem.getElementsByTagName('option')[i].selected === true) {
        opt.classList.add('selected')
        divSelect.innerHTML = elem.getElementsByTagName('option')[i].innerHTML
      }
      ul.appendChild(opt)
    }

    elem.getElementsByTagName('select')[0].style.display = 'none'
    elem.append(divSelect)
    elem.append(ul)

    const newOpt = ul.getElementsByTagName('li')
    for (let i = 0; i < newOpt.length; i++) {
      newOpt[i].addEventListener('click', function () {
        ul.parentNode.querySelector('select').selectedIndex =
          this.getAttribute('data-index')
        ul.parentNode.querySelector('.Ringo-Select__divSelect').innerHTML =
          this.innerHTML
      })
    }

    // CLASS OPENED
    divSelect.addEventListener('click', function (e) {
      e.stopPropagation()
      divSelect.parentNode.classList.toggle('opened')
    })

    ul.addEventListener('click', function (e) {
      e.stopPropagation()
      divSelect.parentNode.classList.remove('opened')
    })
  })

  window.addEventListener('click', function (e) {
    let RSelectUL = document.querySelectorAll('.Ringo-Select ul')
    RSelectUL.forEach(function (elem) {
      e.stopPropagation()
      if (elem.parentNode.classList.contains('opened')) {
        elem.parentNode.classList.remove('opened')
      }
    })
  })
}

// Exemple de Onchange pour select
// let toto2 = document.getElementById('select2').parentNode.querySelector('ul');
// toto2.addEventListener('click', function () {
//     console.log('click marche')
// })

if (document.querySelector('.letter-space')) {
  let titre = document.querySelector('h1').textContent;

  const content = titre.split(" ");

  let newTitle = "";
if(content.length > 1){
  newTitle += '<span>' + content[0] + '</span><br>' + content[1] + '<br>';

    for (let i = 2; i < content.length; i++) {
      newTitle += ' ' + content[i];
    }
  }
  else if (content.length >= 2) {
    newTitle += '<span>' + content[0] + ' ' + content[1] + '</span><br>';

    for (let i = 2; i < content.length; i++) {
      newTitle += ' ' + content[i];
    }
  } else {
    newTitle = content[0];
  }

  document.querySelector('h1').innerHTML = newTitle;
}


// if(document.querySelector('.FrontPage')){
//   let titre = document.querySelectorAll('h2').firstChild.nodeValue; 
//   console.log(titre);
  
  
//   content = titre.split(" ");
//   content[0] = '<span>' +content[0]+ '</span></br>';
//   console.log(content[0]);
//   document.querySelector('h1').innerHTML = content[0] + content[1];
// }


// const spans = document.querySelectorAll('.page--list--item--text');

// // Parcourez les éléments et ajustez le padding si la hauteur est supérieure à 40px
// spans.forEach(span => {
//   const hauteur = span.offsetHeight;
//   if (hauteur > 30) {
//     spans.style.padding = '2rem';
//   }
// });

// Sélectionnez tous les éléments <li> de la classe .page--list--item
const liItems = document.querySelectorAll('.page--list--item');

// Parcourez les éléments et ajustez le padding si la hauteur de l'élément span est supérieure à 40px
liItems.forEach(li => {
  const span = li.querySelector('.page--list--item--text span'); // Sélectionnez l'élément <span> à l'intérieur de chaque <li>
  const text = li.querySelector('.page--list--item--text'); // Sélectionnez l'élément <span> à l'intérieur de chaque <li>
  if (span) {
    
    const hauteur = span.offsetHeight;
    if (hauteur > 20) {
      text.style.padding = '3rem 4rem';
    }
    if (hauteur > 40) {
      text.style.padding = '2rem 4rem';
    }
  }
});